// LOAD PAGE AT TOP AND FORCE REFRESH ON BACK BUTTON CLICK
if(!window.location.hash){
  window.addEventListener('unload', function(){ scrollTo(0,0); });
  history.scrollRestoration = 'manual'
} else {
  // SCROLL TO ANCHOR
  window.addEventListener('load', function(){
    const anchor = window.location.hash;
    if(anchor){
      document.querySelector(anchor).scrollIntoView({
        behavior: 'instant'
      });
    }
  });
}